<template>
  <main class="mb-10 text-black">
    <section class="flex justify-between flex-wrap items-center col-span-12">
      <div class="flex items-center gap-5">
        <h4>
          {{ $t("objectives.titles.lessonPlans") }}
        </h4>
      </div>
      <div class="flex items-center gap-2" v-if="role === 'TEACHER'">
        <Button
          :label="$t('labels.save')"
          :disabled="objective?.length == 0"
          class="btn-primary p-button-sm"
          :loading="loading"
          @click="onNext()"
        />
      </div>
    </section>

    <List
      v-for="(item, i) in lessonPlan"
      :key="i"
      :data="item"
      :error="error[i]"
      :loaderList="loaderList"
      :role="role"
    />
  </main>
</template>

<script lang="ts">
import { LessonPlan } from "@/models/lessonPlan.model";
import { defineAsyncComponent, defineComponent } from "vue";

const List = defineAsyncComponent(() => import("./List/list-materials.vue"));

export default defineComponent({
  name: "LessonPlan",
  components: { List },
  emits: ["onNext"],
  data() {
    return {
      loading: false as boolean,
      error: [false, false] as boolean[],
      lessonPlan: [
        { id: "", name: "", learningObjective: "", materials: [] },
        { id: "", name: "", learningObjective: "", materials: [] },
      ] as LessonPlan[],
    };
  },
  props: {
    objective: [Object],
    lessonPlans: [Array as any],
    loaderList: [Boolean],
    role: [String]
  },
  mounted() {
    this.getLessonPlans();
  },
  methods: {
    onNext(): void {
      this.loading = true;
      let next = true;
      this.lessonPlans?.map((res, index) => {
        if (res.materials.length === 0) {
          this.error[index] = true;
          next = false;
        }
      });
      if (next) {
        setTimeout(() => {
          this.$emit("onNext", 3);
          this.loading = false;
        }, 500);
      }
    },
    getLessonPlans(): void {
      if (this.lessonPlans[0]) {
        this.lessonPlan = this.lessonPlans;
      } else {
        setTimeout(() => {
          this.getLessonPlans();
        }, 200);
      }
    },
  },
});
</script>
